import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { Snapshot, SnapshotThreshold, CreateSnapshotThresholdDto } from 'types';

export const createThreshold = ({
  data,
  snapshotId,
}: {
  data: CreateSnapshotThresholdDto;
  snapshotId: number;
}): Promise<SnapshotThreshold> => {
  return axios.post(`/api/snapshots/${snapshotId}/thresholds`, data);
};

type UseCreateThresholdOptions = {
  snapshotId: number;
  config?: MutationConfig<typeof createThreshold>;
};

export const useCreateThreshold = ({
  config,
  snapshotId,
}: UseCreateThresholdOptions) => {
  return useMutation({
    onMutate: async (newThreshold) => {
      await queryClient.cancelQueries(['snapshot', snapshotId]);

      const previousSnapshot = queryClient.getQueryData<Snapshot>([
        'snapshot',
        snapshotId,
      ]);

      queryClient.setQueryData(['snapshot', snapshotId], {
        ...previousSnapshot,
        thresholds: [
          ...(previousSnapshot?.thresholds || []),
          newThreshold.data,
        ],
      });

      return previousSnapshot;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['snapshot', snapshotId]);
    },
    ...config,
    mutationFn: createThreshold,
  });
};
